

import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Table } from "reactstrap";
import { Pie } from "react-chartjs-2";
import useToken from "../../helpers/useToken"
import TMHLoader from "../TMHLoader/TMHLoader"

export default function RoundsReport() {
    function getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
      }

    const [roundsData, setRoundsData] = useState()
    const [backgroundColorArr, setBackgroundColorArr] = useState([])

    const [isLoading, setIsLoading] = useState(false)
    const { token } = useToken()

    useEffect(() => {
        function initData() {
            setIsLoading(true)
            console.log('RoundReport: get data')
            const myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            const requestOptions = {
                method: 'GET',
                headers: myHeaders
            };

            fetch(process.env.REACT_APP_BASE_URL + "analytics/rounds_report", requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        var json = result.json
                        // console.log(json)
                        if (result.ok) {
                            setRoundsData(json.data)
                            let colorArr = ['#95D562', '#3109ED']
                            for (var i in json.data.labels) {
                                colorArr.push(getRandomColor())
                            }
                            setBackgroundColorArr(colorArr)
                        }
                        else {
                            // console.log(result.json.message)

                        }
                        setIsLoading(false)
                    }
                )
        }

        initData()
    }, [token])

    return (
        <TMHLoader active={isLoading}>

            <Card>
                <CardHeader>
                    <CardTitle tag="h2" className="text-center">
                        Users by round report
                    </CardTitle>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md="7">
                        <Table striped className="tablesorter">
                                <thead className="text-primary">
                                    <tr>
                                        <th>Round</th>
                                        <th>Users in round</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        roundsData && roundsData.labels.map((_, index) => {
                                            return (<tr key={index}>
                                                <td>{roundsData.labels[index]}</td>
                                                <td>{roundsData.datasets[index]}</td>
                                                <td>{parseFloat(roundsData.datasets[index] * 100 / roundsData.total).toFixed(2) + "%"}</td>
                                            </tr>)
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Col>
                        <Col md="5">
                            {
                                roundsData && <Pie data={{
                                    labels: roundsData.labels,
                                    datasets: [{
                                        data: roundsData.datasets,
                                        backgroundColor: backgroundColorArr,
                                        hoverOffset: 2
                                    }]
                                }} config={{
                                    type: 'doughnut'
                                }} />
                            }
                        </Col>

                    </Row>

                </CardBody>
            </Card>

        </TMHLoader>
    )
}